import Cookies from "universal-cookie";

// Anulação de títulos (Backoffice, só admin). Mesmo transporte de `financialGovernanceApi.js`
// (fetch + Bearer do cookie), mas devolve `{ ok, status, body }` e nunca lança, para o painel
// compartilhado com a Diretoria ler `message`/`errorCode` mesmo nas respostas de erro.

const cookies = new Cookies();
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const resolveUrl = (path) => {
  if (!BASE) return null;
  try {
    const base = new URL(BASE);
    if (!["http:", "https:"].includes(base.protocol) || base.username || base.password) return null;
    const basePath = base.pathname.replace(/\/+$/, "");
    const url = new URL(`${basePath}/${path}`, `${base.origin}/`);
    return url.origin === base.origin ? url : null;
  } catch {
    return null;
  }
};

const request = async (path, { method = "GET", body } = {}) => {
  const url = resolveUrl(path);
  if (!url) return { ok: false, status: 0, body: { message: "Backoffice não configurado." } };
  const { token } = cookies.get("userId") || {};
  if (typeof token !== "string" || !token) {
    return { ok: false, status: 401, body: { message: "Faça login novamente." } };
  }
  try {
    const response = await fetch(url.toString(), {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => null);
    return { ok: response.ok, status: response.status, body: data };
  } catch {
    return { ok: false, status: 0, body: { message: "Não foi possível comunicar com o servidor." } };
  }
};

const base = (companyId) => `title-annulments/companies/${encodeURIComponent(String(companyId))}`;

export const fetchTitleAnnulments = (companyId) => request(base(companyId));

export const annulTitle = (companyId, body) => request(base(companyId), { method: "POST", body });

export const previewTitleAnnulment = (companyId, body) => (
  request(`${base(companyId)}/preview`, { method: "POST", body })
);

export const revokeTitleAnnulment = (companyId, id, body) => (
  request(`${base(companyId)}/${encodeURIComponent(String(id))}/revoke`, { method: "POST", body })
);

export const reprocessTitleAnnulments = (companyId, body = {}) => (
  request(`${base(companyId)}/reprocess`, { method: "POST", body })
);

export const titleAnnulmentsApi = {
  preview: previewTitleAnnulment,
  annul: annulTitle,
  revoke: revokeTitleAnnulment,
  reprocess: reprocessTitleAnnulments,
};
